import { useEffect, useRef } from "react";

export const SaturnCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let t = 0;

    const stars = Array.from({ length: 90 }, () => ({
      x: Math.random(),
      y: Math.random(),
      r: Math.random() * 1.4 + 0.3,
      s: Math.random() * 0.6 + 0.2,
    }));

    const resize = () => {
      const parent = canvas.parentElement;
      canvas.width = parent.offsetWidth * window.devicePixelRatio;
      canvas.height = parent.offsetHeight * window.devicePixelRatio;
    };
    resize();
    window.addEventListener("resize", resize);

    const draw = () => {
      const w = canvas.width;
      const h = canvas.height;
      const dpr = window.devicePixelRatio;
      ctx.clearRect(0, 0, w, h);

      ctx.fillStyle = "rgba(248,250,252,0.55)";
      stars.forEach((st) => {
        const tw = 0.35 + 0.65 * Math.abs(Math.sin(t * st.s * 0.02 + st.x * 10));
        ctx.globalAlpha = tw * 0.7;
        ctx.beginPath();
        ctx.arc(st.x * w, st.y * h, st.r * dpr, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.globalAlpha = 1;

      t += 16;
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={canvasRef} data-testid="saturn-canvas" className="absolute inset-0 h-full w-full" />;
};
